export enum StatusEnum {
  Init = "INIT",
  Failed = "FAILED",
  Success = "SUCCESS",
}
